module.exports = __webpack_public_path__ + "static/media/documents-brikk-preview.b82742bc.png";